
import { FilterTypesEnum } from '../enums/filters-types.enum';
import { ChipModel } from '../../Forms/models/chip.model';
import { FilterOptionModel } from '../models/filter-option.model';
import { FilterTypeModel } from './abstract-filter-type.model';



export class FilterTypeRadioModel<T = any> extends FilterTypeModel<T> {
    readonly key: FilterTypesEnum = FilterTypesEnum.radio;
    declare options: FilterOptionModel<T>[];
    protected value: T;
    protected currentValue: T;

    constructor(
        id: string,
        label: string,
        options?: FilterOptionModel<T>[],
        value?: T,
    ) {
        super(id, label);
        this.options = options || [];
        this.setValue(value || null);
    }

    /**
     * Set the active value for a filter
     * @param value
     */
    setValue(value: T): void {
        this.value = value;
        this.chips = [];
        // make chips
        if (this.options && this.value !== null) {
            const chipValue = this.options.find(option => option.value === value);
            this.chips = [
                {
                    label: chipValue?.label
                }
            ];
        };
        this.cancelChanges();
    }
    getValue(): T {
        return this.value;
    }
    removeChip(chip: ChipModel): void {
        this.setValue(null);
    }
    clear(): void {
        this.setValue(null);
    }
    setCurrentValue(value: T): void {
        this.currentValue = value;
        this.currentChips = [];
        // make chips
        if (this.options && this.currentValue !== null) {
            const chipValue = this.options.find(option => option.value === this.currentValue);
            this.currentChips = [
                {
                    label: chipValue?.label
                }
            ];
        };
    }
    getCurrentValue(): T {
        return this.currentValue;
    }
    removeCurrentChip(chip: ChipModel): void {
        this.setCurrentValue(null);
    }
    cancelChanges(): void {
        this.setCurrentValue(this.value);
    }
}
